import { useState } from "react"
import classNames from "classnames"
import { isValidPhoneNumber } from "libphonenumber-js"
import PhoneInput from "react-phone-number-input/input"
import type { E164Number } from "libphonenumber-js/types.cjs"
import "react-phone-number-input/style.css"
import JoinCard from "../components/JoinCard"
import { TotalSteps } from "../joinSteps"

interface Props {
  referrerName: string
  phone?: E164Number
  onChange: (phone?: E164Number) => void
  onSubmit: () => Promise<unknown>
  error: string
}

export default function PhoneStep({ referrerName, phone, onChange, onSubmit, error }: Props) {
  const [sending, setSending] = useState(false)
  const valid = !!phone && isValidPhoneNumber(phone, "US")

  const submit = async () => {
    setSending(true)
    await onSubmit()
    setSending(false)
  }

  return (
    <JoinCard
      title="Reservations made easy"
      subtitle={`${referrerName} invited you to Artemis`}
      step={1}
      totalSteps={TotalSteps}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault()
          if (valid && !sending) {
            submit()
          }
        }}
      >
        <label className="form-label join-label" htmlFor="phone">
          Phone number
        </label>
        <PhoneInput
          id="phone"
          className={classNames("form-control form-control-lg", { "is-invalid": !!error })}
          defaultCountry="US"
          placeholder="(555) 555-5555"
          autoComplete="tel"
          value={phone}
          disabled={sending}
          onChange={onChange}
        />
        {error && <div className="invalid-feedback d-block">{error}</div>}

        <button
          className="btn btn-primary btn-lg w-100 mt-3"
          type="submit"
          disabled={!valid || sending}
        >
          {sending ? "Sending..." : "Send code"}
        </button>
        <p className="join-fine-print">Use the number on your Resy account. We'll text you a code.</p>
      </form>
    </JoinCard>
  )
}
